// var/artest/containers/www-services/public/model-preview/src/js/components/game-scene-oeuvres-panel-view/game-scene-oeuvres-panel-view.ts
function OeuvreTitleGetter(item) {
  return item.title || item.uid;
}
function OeuvreTitleSortFn(a, b) {
  return (a.title || a.uid).localeCompare(b.title || b.uid);
}
var GameSceneOeuvresPanelStateComponent = class {
  constructor($scope, $rootScope, $timeout, $compile, $oeuvresHandler, $playerHandler, gameSceneService, userActionHistoryService, entitySelectionService, contextMenuService, catalogsService) {
    this.$scope = $scope;
    this.$oeuvresHandler = $oeuvresHandler;
    this.$playerHandler = $playerHandler;
    this.catalogsService = catalogsService;
    this.__cache_getItemsOfOeuvreLists_lists = null;
    this.__cache_getFilteredItemsOfOeuvreLists = {};
    this.oeuvre_list_items_order = "default";
    this.oeuvres_lists = {
      hidden_off_catalog: [],
      hidden_on_catalog: [],
      on_catalog: [],
      off_catalog: []
    };
    this.filtering = {
      enabled: true
    };
  }
  setOeuvreListItemsOrder(order) {
    this.oeuvre_list_items_order = order;
    this.clearCache();
    this.buildOeuvresLists(this.oeuvres_lists);
    this.getItemsOfOeuvreLists(order, false);
  }
  clearCache() {
    this.__cache_getItemsOfOeuvreLists_lists = null;
    this.__cache_getFilteredItemsOfOeuvreLists = {};
  }
  filterItems() {
    this.__cache_getFilteredItemsOfOeuvreLists = {};
    this.getFilteredItemsOfOeuvreLists();
  }
  getFilteredItemsOfOeuvreLists() {
    let { search } = this.filtering;
    if (!search)
      search = "";
    search = search.trim().toLowerCase();
    let cache_key = `${search}`;
    if (!this.__cache_getFilteredItemsOfOeuvreLists[cache_key]) {
      let items = this.getItemsOfOeuvreLists();
      if (!items) {
        return null;
      }
      items = [...items];
      if (search) {
        for (let i = items.length - 1; i >= 0; i--) {
          let title = OeuvreTitleGetter(items[i].oeuvre);
          if (title.toLowerCase().indexOf(search) === -1) {
            items.splice(i, 1);
          }
        }
      }
      if (items) {
        this.__cache_getFilteredItemsOfOeuvreLists[cache_key] = items;
      }
    }
    return this.__cache_getFilteredItemsOfOeuvreLists[cache_key];
  }
  getItemsOfOeuvreLists(order = this.oeuvre_list_items_order, use_cache = true) {
    let result = this.__cache_getItemsOfOeuvreLists_lists;
    if (result == null)
      use_cache = false;
    if (order != this.oeuvre_list_items_order)
      use_cache = false;
    if (!use_cache) {
      result = null;
      switch (order) {
        case "default":
        default:
          break;
        case "title":
          result = [...this.oeuvres_lists.hidden_off_catalog, ...this.oeuvres_lists.hidden_on_catalog].sort(OeuvreTitleSortFn).map(function(oeuvre) {
            return {
              setted: false,
              oeuvre
            };
          }).concat([...this.oeuvres_lists.on_catalog, ...this.oeuvres_lists.off_catalog].sort(OeuvreTitleSortFn).map(function(oeuvre) {
            return {
              setted: true,
              oeuvre
            };
          }));
      }
      if (result == null) {
        result = [...this.oeuvres_lists.hidden_off_catalog, ...this.oeuvres_lists.hidden_on_catalog].map(function(oeuvre) {
          return {
            setted: false,
            oeuvre
          };
        }).concat([...this.oeuvres_lists.on_catalog, ...this.oeuvres_lists.off_catalog].map(function(oeuvre) {
          return {
            setted: true,
            oeuvre
          };
        }));
      }
      if (order == this.oeuvre_list_items_order) {
        this.__cache_getItemsOfOeuvreLists_lists = result;
      }
    }
    return result;
  }
  buildOeuvresLists(oeuvres_lists = { hidden_off_catalog: [], hidden_on_catalog: [], on_catalog: [], off_catalog: [] }) {
    oeuvres_lists.hidden_on_catalog = [];
    oeuvres_lists.hidden_off_catalog = [];
    oeuvres_lists.on_catalog = [];
    oeuvres_lists.off_catalog = [];
    let visible = {};
    let hidden = {};
    for (let uid in this.$oeuvresHandler.oeuvres) {
      let oeuvre = this.$oeuvresHandler.oeuvres[uid];
      if (oeuvre.isSetted && oeuvre.mesh && oeuvre.mesh.visible) {
        visible[uid] = oeuvre;
      } else {
        hidden[uid] = oeuvre;
      }
    }
    let catalog_client_oeuvre_items = this.catalogsService.getCurrentCatalogItemsByType("client_oeuvre") || [];
    for (let item of catalog_client_oeuvre_items) {
      if (visible[item.uid]) {
        oeuvres_lists.on_catalog.push(visible[item.uid]);
        delete visible[item.uid];
        continue;
      }
      if (hidden[item.uid]) {
        oeuvres_lists.hidden_on_catalog.push(hidden[item.uid]);
        delete hidden[item.uid];
        continue;
      }
    }
    for (let uid in visible)
      oeuvres_lists.off_catalog.push(visible[uid]);
    for (let uid in hidden)
      oeuvres_lists.hidden_off_catalog.push(hidden[uid]);
    return oeuvres_lists;
  }
  settedOeuvresCount() {
    let { $scope } = this;
    return Object.keys($scope.oeuvres).filter(function(key) {
      return $scope.oeuvres[key].isSetted;
    }).length;
  }
  nonSettedOeuvresCount() {
    let { $scope } = this;
    return Object.keys($scope.oeuvres).length - this.settedOeuvresCount();
  }
  focusToOeuvre(uid) {
    let { $scope } = this;
    var oeuvre;
    uid = typeof uid == "object" ? uid.uid : uid;
    for (var i in $scope.oeuvres) {
      if ($scope.oeuvres[i].uid == uid) {
        oeuvre = $scope.oeuvres[i];
        break;
      }
    }
    if (!oeuvre)
      throw new Error("Invalid argument :: Failed to focus to oeuvre, oeuvre not found");
    var wrapper = globalThis.jQuery("#oeuvres-list > .content");
    var curscroll = wrapper.scrollLeft();
    var elem = globalThis.jQuery("#oeuvre-item-" + oeuvre.uid);
    var offset = elem.offset();
    wrapper.scrollLeft(curscroll + offset.left - window.innerWidth / 2);
  }
  toggleOpen() {
    let { $scope } = this;
    $scope.open = !$scope.open;
    console.log("view.game-scene.oeuvres-panel :: toggleOpen()", $scope.open);
    this.$playerHandler.setConfig("view.game-scene.oeuvres-panel/panel-open", !!$scope.open);
    this.clearCache();
  }
};
export {
  GameSceneOeuvresPanelStateComponent
};
